import { useTranslate } from '@tolgee/react';
import { Send } from 'lucide-react';
import { useSendFileImage } from 'views/Conversation/Chat/components/MessageEditor/Toolbar/ImageUpload';

interface LogisticsImageSendButtonProps {
  imageUrl: string;
  onClose?: () => void;
}

export const LogisticsImageSendButton = (props: LogisticsImageSendButtonProps) => {
  const { imageUrl, onClose } = props;
  const sendFileImage = useSendFileImage();
  const { t } = useTranslate();

  return (
    <div
      className="flex items-center gap-1 text-[14px] cursor-pointer hover:text-[#cecece] mr-6"
      onClick={() => {
        if (imageUrl) {
          sendFileImage(imageUrl);
          onClose?.();
        }
      }}
    >
      <Send size={14} />
      {t('scene.chatWorkspace.messageEditor.action.sendImage')}
    </div>
  );
};
